import React, { useContext } from 'react'

import { ItemContext, ItemDispatchContext } from 'src/contexts/itemContext'

import { t } from 'i18next'
import View from 'src/components/atoms/View'
import Text from 'src/components/atoms/TextNew'
import Button from 'src/components/atoms/Button'
import { confirmPickUp } from 'src/helpers/api/confirmPickUp'

interface Props {
  offerId: number
}

const PickUpBar = ({ offerId }: Props): JSX.Element => {
  const itemContext = useContext(ItemContext)
  const dispatchItemContext = useContext(ItemDispatchContext)

  if (itemContext === null || dispatchItemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }
  return (
    <View
      onClick={(e) => {
        e.stopPropagation()
      }}
      className="h-[104px] px-6 flex justify-between cursor-auto shadow-bothMedium rounded-b-4 bg-gradient-to-b from-blueGradientStart to-blueGradientStop">
      <View className="w-[300px] flex justify-center items-center text-center">
        <Text className="text-xl text-white font-SemiBold">
          <>{t('in_realization_list_item.confirm_pick_up')}</>
        </Text>
      </View>

      <View className="flex flex-col justify-center gap-2">
        <View className="flex gap-2 justify-around items-center">
          <Button
            color="transparent"
            variant="medium"
            onClick={() => {
              dispatchItemContext({ type: 'TOGGLE_VIEW' })
            }}>
            <Text className="text-xl text-white font-SemiBold">
              <>{t('auction_contract_modal.resign')}</>
            </Text>
          </Button>
          <Button
            variant="medium"
            dataTestId="confirm-pick-up-button"
            onClick={() => {
              confirmPickUp({ offerId })
                .then((payload) => {
                  dispatchItemContext({ type: 'CONFIRM_PICK_UP_SUCCESS' })
                })
                .catch(() => {
                  dispatchItemContext({ type: 'CONFIRM_PICK_UP_FAILURE' })
                })
            }}>
            <Text className="text-xl  text-white font-SemiBold">
              <>{t('in_realization_list_item.confirm_button')}</>
            </Text>
          </Button>
        </View>
      </View>
    </View>
  )
}

export default PickUpBar
